import { render, staticRenderFns } from "./AdditionalDataForm.vue?vue&type=template&id=723c46b9&lang=pug"
import script from "./AdditionalDataForm.vue?vue&type=script&lang=js"
export * from "./AdditionalDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports